import $ from 'jquery'

const dfp = {};

const bannerMobile = [[300, 50], [320, 100]];

/**
 * Every ad unit the site can show. A slot is only defined when its cs-ads
 * (by id or data-id) is on the page and matches its data-condition, so any
 * position can go in any template.
 * `mobile` overrides `size` at 650px or less; `device` limits the slot to one of them.
 */
const slots = [
    { path: '/60012700/billboard1', size: [970, 120], mobile: bannerMobile, id: 'Billboard' },
    { path: '/60012700/leaderboard1', size: [970, 90], mobile: bannerMobile, id: 'Leaderboard_1' },
    { path: '/60012700/leaderboard2', size: [970, 90], mobile: bannerMobile, id: 'Leaderboard_2' },
    { path: '/60012700/leaderboard3', size: [970, 90], mobile: bannerMobile, id: 'Leaderboard_3' },
    { path: '/60012700/leaderboard4', size: [970, 90], mobile: bannerMobile, id: 'Leaderboard_4' },
    { path: '/60012700/leaderboard5', size: [970, 90], mobile: bannerMobile, id: 'Leaderboard_5' },
    { path: '/60012700/skyright', size: [160, 600], device: 'desktop', id: 'Sky_R' },
    { path: '/60012700/skyleft', size: [160, 600], device: 'desktop', id: 'Sky_L' },
    { path: '/60012700/medium1', size: [300, 250], id: 'Medium_1' },
    { path: '/60012700/medium2', size: [300, 250], id: 'Medium_2' },
    { path: '/60012700/medium3', size: [300, 250], id: 'Medium_3' },
    { path: '/60012700/medium4', size: [300, 250], id: 'Medium_4' },
    { path: '/60012700/medium5', size: [300, 250], id: 'Medium_5' },
    { path: '/60012700/medium1', size: [300, 250], device: 'mobile', id: 'Medium_Mobile_1' },
    { path: '/60012700/medium2', size: [300, 250], device: 'mobile', id: 'Medium_Mobile_2' },
    { path: '/60012700/medium3', size: [300, 250], device: 'mobile', id: 'Medium_Mobile_3' },
    { path: '/60012700/medium4', size: [300, 250], device: 'mobile', id: 'Medium_Mobile_4' },
    { path: '/60012700/medium5', size: [300, 250], device: 'mobile', id: 'Medium_Mobile_5' },
];

/**
 * data-condition of a cs-ads (e.g. "> 650", "<= 650") against the viewport width
 */
dfp.matchesCondition = (condition) => {
    return condition === "" || condition === undefined || eval(window.innerWidth + condition);
};

const isOnPage = (id) => $(`cs-ads#${id}, cs-ads[data-id="${id}"]`)
    .filter((_idx, el) => dfp.matchesCondition($(el).data('condition')))
    .length > 0;

dfp.push = (format, conditions) => {
    if (dfp.matchesCondition(conditions)) {
        window.googletag.cmd.push(function () {
            window.googletag.display(format);
        })
    }
};

dfp.domInjection = (dfpUrl) => {

    if (dfpUrl) {
        let script = document.createElement('script');
        let node = document.getElementsByTagName('body')[0];

        script.type = 'text/javascript';
        script.async = true;
        script.defer = false;
        script.src = dfpUrl;
        node.appendChild(script);
    }
};


dfp.initializedfp = () => {
    window.googletag = window.googletag || {};
    window.googletag.cmd = window.googletag.cmd || [];

    let section = $('meta[content][name="sectionTarget"]').attr('content');
    let type = $('meta[content][name="type"]').attr('content');
    let articleId = $('meta[content][name="articleId"]').attr('content');

    googletag.cmd.push(function() {
        googletag.pubads().addEventListener("slotRenderEnded", function handler(event) {
            const slot = event.slot;
            if (event.isEmpty) {
                let slotElement = slot.getSlotElementId();
                googletag.destroySlots([slot]);
                console.log(slotElement);
                $( '#' + slotElement ).remove();
            }
        });
    });

    const isDesktop = window.innerWidth > 650;

    window.googletag.cmd.push(function () {
        slots.forEach(({ path, size, mobile, device, id }) => {
            if ((device && device !== (isDesktop ? 'desktop' : 'mobile')) || !isOnPage(id)) {
                return;
            }

            window.googletag.defineSlot(path, isDesktop || !mobile ? size : mobile, id).addService(window.googletag.pubads());
        });

        window.googletag.pubads().enableSingleRequest();
        if (!isDesktop) {
            window.googletag.pubads().collapseEmptyDivs();
        }
        window.googletag.pubads().setTargeting('Section', [section]);
        window.googletag.pubads().setTargeting('ArticleId', [articleId]);
        window.googletag.pubads().setTargeting('Type', [type]);

        window.googletag.enableServices();
    });

};

export default dfp;
